import React, { useMemo } from "react";

import { Theme, useTheme } from "@mui/material/styles";

import { InvoiceViewProps, ShippingCartType } from "./ShippingCart.types";
import {
  formatLocalizedMoney,
  logDebug,
  mergeProperties,
} from "packable-components";
import { Divider, Grid, Typography } from "@mui/material";
import { InvoiceItemView } from "./InvoiceItemView";

const getStyles = (theme: Theme) => ({
  PackableInvoiceViewContaner: {
    pl: 1,
    pr: 1,
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
  },
  InvoiceViewContainerDivider: {
    mb: 2,
  },
});

export const InvoiceView: React.FC<InvoiceViewProps> = (
  props
): React.JSX.Element => {
  const { shippingCartPrice, styles } = props;

  logDebug("InvoiceView PROPS");
  logDebug(props);

  const theme = useTheme();

  const defaultStyles = useMemo(() => getStyles(theme), [theme]);
  const effectiveStyles = useMemo(
    () =>
      styles === undefined
        ? defaultStyles
        : mergeProperties(defaultStyles, styles),
    [defaultStyles, styles]
  );

  logDebug("InvoiceView effectiveStyles");
  logDebug(effectiveStyles);

  return (
    <Grid
      className="PackableInvoiceViewContaner"
      sx={effectiveStyles.PackableInvoiceViewContaner}
    >
      {shippingCartPrice.itemPrices
        ?.sort(
          (a, b) =>
            Number(a.itemLabel.substring(3)) - Number(b.itemLabel.substring(3))
        )
        .map((price) => (
          <InvoiceItemView
            shippingCartType={shippingCartPrice.cartType}
            shippingCartItemPrice={price}
            styles={effectiveStyles}
          />
        ))}
      <Divider
        className="InvoiceViewContainerDivider"
        sx={effectiveStyles.InvoiceViewContainerDivider}
      />
      {shippingCartPrice.cartType === ShippingCartType.STORAGE && (
        <Grid>
          <Typography variant="body1">
            {`Storage Sub-Total: ${formatLocalizedMoney(
              shippingCartPrice.subTotal,
              2,
              shippingCartPrice.currency,
              Intl.DateTimeFormat().resolvedOptions().locale
            )}`}
          </Typography>
          <Typography variant="body1">
            {`Tax: ${formatLocalizedMoney(
              shippingCartPrice.tax,
              2,
              shippingCartPrice.currency,
              Intl.DateTimeFormat().resolvedOptions().locale
            )}`}
          </Typography>
          <Typography sx={{ fontWeight: 700 }} variant="body1">
            {`Storage Total: ${formatLocalizedMoney(
              shippingCartPrice.total,
              2,
              shippingCartPrice.currency,
              Intl.DateTimeFormat().resolvedOptions().locale
            )}`}
          </Typography>
        </Grid>
      )}
      {shippingCartPrice.cartType === ShippingCartType.HOME && (
        <Grid>
          <Typography variant="body1">
            {`Shipping Sub-Total: ${formatLocalizedMoney(
              shippingCartPrice.subTotal,
              2,
              shippingCartPrice.currency,
              Intl.DateTimeFormat().resolvedOptions().locale
            )}`}
          </Typography>
          <Typography variant="body1">
            {`Tax: ${formatLocalizedMoney(
              shippingCartPrice.tax,
              2,
              shippingCartPrice.currency,
              Intl.DateTimeFormat().resolvedOptions().locale
            )}`}
          </Typography>
          <Typography sx={{ fontWeight: 700 }} variant="body1">
            {`Shipping Total: ${formatLocalizedMoney(
              shippingCartPrice.subTotal,
              2,
              shippingCartPrice.currency,
              Intl.DateTimeFormat().resolvedOptions().locale
            )}`}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};
